import type { ChatDocumentDTO } from '@shared/schemas/chat';

const DEFAULT_DOCUMENT_TITLE = 'Document conversationnel';
const DEFAULT_DOCUMENT_SUMMARY = 'Aperçu documentaire en cours de préparation.';

export function getDocumentTitle(document: ChatDocumentDTO) {
  const normalizedTitle = document.title.trim();

  if (normalizedTitle.length > 0 && normalizedTitle.toLowerCase() !== 'undefined') {
    return normalizedTitle;
  }

  if (document.filename && document.filename.trim().length > 0) {
    return document.filename.trim();
  }

  return DEFAULT_DOCUMENT_TITLE;
}

function normalizeDocumentContentFence(content: string) {
  if (!content.trim()) {
    return content;
  }

  const withoutOpeningFence = content.replace(/^\s*```(?:markdown|md)?\s*\n?/i, '');
  return withoutOpeningFence.replace(/\n?```\s*$/i, '');
}

export function getDocumentContent(document: ChatDocumentDTO) {
  if (document.kind !== 'assistant-brief') {
    return document.content;
  }

  return normalizeDocumentContentFence(document.content);
}

export function getDocumentSummary(document: ChatDocumentDTO) {
  const normalizedSummary = document.summary?.trim();

  if (normalizedSummary && normalizedSummary.toLowerCase() !== 'undefined') {
    return normalizedSummary;
  }

  const normalizedContent = getDocumentContent(document).trim();

  if (normalizedContent.length > 0) {
    return normalizedContent.slice(0, 220);
  }

  return DEFAULT_DOCUMENT_SUMMARY;
}

export function getDocumentWordCount(document: ChatDocumentDTO) {
  const normalizedContent = getDocumentContent(document).trim();

  if (normalizedContent.length === 0) {
    return 0;
  }

  return normalizedContent.split(/\s+/).filter((token) => token.length > 0).length;
}

export function formatStreamingMetricsLabel(wordCount: number) {
  if (wordCount === 0) {
    return 'Génération en cours';
  }

  return `Génération en cours · ${wordCount.toLocaleString('fr-FR')} mots`;
}

export function getDocumentPreviewExcerpt(document: ChatDocumentDTO, maxCharacters = 480) {
  const normalizedContent = getDocumentContent(document).trim();

  if (normalizedContent.length <= maxCharacters) {
    return normalizedContent;
  }

  const truncated = normalizedContent.slice(0, maxCharacters);
  const lastWhitespaceIndex = truncated.lastIndexOf(' ');

  if (lastWhitespaceIndex < Math.floor(maxCharacters * 0.65)) {
    return `${truncated.trimEnd()}...`;
  }

  return `${truncated.slice(0, lastWhitespaceIndex).trimEnd()}...`;
}
